import styled, { useTheme } from 'foundations-theming/utils';
import { useState } from 'react';
import DynamicMetadataEditor, { FIELD_VISIBILITY_CONTROLS_HEIGHT, COMPACT_VERTICAL_PADDING } from './DynamicMetadataEditor';
import { jsx as _jsx } from "react/jsx-runtime";
const TABS_HEIGHT = FIELD_VISIBILITY_CONTROLS_HEIGHT + COMPACT_VERTICAL_PADDING * 2 + 1;

// this wrapper's padding lets the non-expanded metadata editor LOOK like it's positioned
// inline relatively (even though it's absolutely positioned using the wrapperStyleFn).
// if the collapsed metadata editor height changes, then we will have to update this padding-top
const PositonalWrapper = styled.div.withConfig({
  displayName: "AbsoluteMetadataEditor__PositonalWrapper",
  componentId: "sc-1tlavc8-0"
})(["position:relative;z-index:1;padding-top:", "px;"], ({
  metadataHeight
}) => Math.max(FIELD_VISIBILITY_CONTROLS_HEIGHT, metadataHeight - TABS_HEIGHT) + COMPACT_VERTICAL_PADDING * 2 + 1);
const AbsoluteMetadataEditor = props => {
  const trellisTheme = useTheme();
  const [metadataHeight, setMetadataHeight] = useState(0);
  const wrapperStyleFn = () => `
    position: absolute;
    bottom: 0;
    border-top: 1px solid ${trellisTheme.color['border-core-subtle']};
  `;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized can't migrate math to tokens
    _jsx(PositonalWrapper, {
      metadataHeight: metadataHeight || 0,
      children: /*#__PURE__*/_jsx(DynamicMetadataEditor, Object.assign({}, props, {
        wrapperStyleFn: wrapperStyleFn,
        onHeightChange: setMetadataHeight
      }))
    })
  );
};
AbsoluteMetadataEditor.displayName = 'AbsoluteMetadataEditor';
export default AbsoluteMetadataEditor;